// extracted by mini-css-extract-plugin
export default {"topNav":"SG-z","category":"TG-z","noArrow":"UG-z","alternative":"VG-z","topLevelNavItem":"WG-z","navContainer":"XG-z","subcategoryHeading":"YG-z","subcategory":"ZG-z"};